export const environmentalRecordTypeCatalog: Record<string, { urlCheck: string }> = {
  'Environmental Debts': {
    urlCheck: 'https://servicos.ibama.gov.br/sicafiext/'
  },
  'Environmental Embargoes': {
    urlCheck:
      'https://servicos.ibama.gov.br/ctf/publico/areasembargadas/ConsultaPublicaAreasEmbargadas.php'
  }
}
